var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
var StyledViableInstallmentBox = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ", ";\n  border: 1px solid ", ";\n  ", ";\n  margin: 0 0.5rem 0.5rem 0;\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 3px;\n  font-size: 0.9375rem;\n  line-height: 2.5rem;\n  cursor: pointer;\n  &:last-of-type {\n    margin-right: 0;\n  }\n"], ["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
    ";\n  border: 1px solid ", ";\n  ",
    ";\n  margin: 0 0.5rem 0.5rem 0;\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 3px;\n  font-size: 0.9375rem;\n  line-height: 2.5rem;\n  cursor: pointer;\n  &:last-of-type {\n    margin-right: 0;\n  }\n"])), function (_a) {
    var component = _a.theme.component;
    return component.installmentcalculator.backgroundColor;
}, function (_a) {
    var component = _a.theme.component;
    return component.installmentcalculator.borderColor;
}, function (_a) {
    var selected = _a.selected, theme = _a.theme;
    return selected && "color: #ffffff; background-color: " + theme.primary.color.normal;
});
export var ViableInstallmentBox = function (_a) {
    var isSelected = _a.isSelected, onChange = _a.onChange, value = _a.value;
    return (React.createElement(StyledViableInstallmentBox, { "data-testid": "viable-installment-box", onClick: onChange, selected: isSelected }, value));
};
export default ViableInstallmentBox;
var templateObject_1;
//# sourceMappingURL=index.js.map